import React, { useEffect, useState } from "react";
import { Stack, Text, CommandBarButton } from "@fluentui/react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import {
  Autocomplete,
  TextField,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  InputLabel,
  FormControl,
  FormControlLabel,
} from "@mui/material";
import styles from "./UserProfile.module.css";
import {
  getallcompanies,
  getallindustries,
  getalllocations,
  getUserProfileDetails,
  updateUserProfileDetails,
  getRoles,
} from "../../api";
import { UserProfileDetails } from "../../api/models";
import { Loader } from "../CarbonAIChat/common/Common";

export const UserProfile = () => {
  const maxOptions = 5; // Maximum number of options to display
  const [formattedAreasOfInterest, setFormattedAreasOfInterest] =
    useState<string>("");

  const [industryOptions, setIndustryOptions] = useState<{ name: string }[]>(
    []
  );
  const [companyerror, setcompanyerror] = useState<string>("");
  // const [worklocationerror, setworklocationerror] = useState<string>("");
  const [userlocationerror, setuserlocationerror] = useState<string>("");
  // const [keyinterestserror, setkeyinterestserror] = useState<string>("");
  const [userprofile, setUserProfile] = useState<UserProfileDetails>();
  const [originalprofile, setOriginalProfile] = useState<UserProfileDetails>();
  // const [keyinterests, setKeyInterests] = useState<string>("");
  const [company, setCompany] = useState<string>(""); // Company selection
  const [companyOptions, setCompanyOptions] = useState<{ name: string }[]>([]);
  const [locationoptions, setLocationOptions] = useState<{ name: string }[]>(
    []
  );
  const [location, setLocation] = useState<string>(""); // Location selection
  const [role, setRole] = useState<string>("");
  const [roleOptions, setRoleOptions] = useState<{ name: string }[]>([]);
  const [selectedIndustries, setSelectedIndustries] = useState<string[]>([]); // Industries selection
  const [personalization, setPersonalization] = useState<boolean>(true);
  const [saveDisabled, setSaveDisabled] = useState<boolean>(true);
  const [customizedPrompting, setCustomizedPrompting] = useState<string>("");

  const [loading, setLoading] = useState(true); // Loading state to show loader before user profile is fetched
  const [showModal, setShowModal] = useState(false);
  const [modalMsg, setModalMsg] = useState("");

  // Handle company change from MUI Autocomplete
  const handleCompanyChange = (
    event: React.SyntheticEvent<Element, Event>,
    newValue: string | null
  ) => {
    if (newValue) {
      if (newValue.length > 255) {
        setcompanyerror("Company name cannot exceed 255 characters");

        setTimeout(() => {
          setcompanyerror("");
        }, 2000); // 2000 milliseconds = 2 seconds

        return;
      }
      setCompany(newValue); // Update state with the selected company
    }
    setcompanyerror("");
  };

  const handleCompanyInputChange = (
    event: React.SyntheticEvent<Element, Event>,
    newInputValue: string
  ) => {
    if (newInputValue.length > 255) {
      setcompanyerror("Company name cannot exceed 255 characters");
      return;
    }
    setcompanyerror(null); // Clear error if input is valid
    setCompany(newInputValue); // Update state with user-typed value
  };

  const handleRoleChange = (
    event: React.SyntheticEvent<Element, Event>,
    newValue: string | null
  ) => {
    if (newValue) {
      if (newValue.length > 255) {
        setTimeout(() => {}, 2000); // 2000 milliseconds = 2 seconds

        return;
      }
      setRole(newValue); // Update state with the selected company
    }
  };

  const handleRoleInputChange = (
    event: React.SyntheticEvent<Element, Event>,
    newInputValue: string
  ) => {
    if (newInputValue.length > 255) {
      return;
    }
    setRole(newInputValue); // Update state with user-typed value
  };

  // Handle industry change for Multi-select
  const handleIndustryChange = (event: any) => {
    const {
      target: { value },
    } = event;
    setSelectedIndustries(typeof value === "string" ? value.split(",") : value);
  };

  // // Handle country change for Multi-select
  // const handleCountryChange = (event: any) => {
  //   const {
  //     target: { value },
  //   } = event;
  //   setSelectedCountries(typeof value === "string" ? value.split(",") : value);
  // };

  // Handle user location change from MUI Autocomplete
  const handleUserLocationChange = (
    event: React.SyntheticEvent<Element, Event>,
    newValue: string | null
  ) => {
    if (newValue) {
      if (newValue.length > 255) {
        setuserlocationerror("User Location cannot exceed 255 characters");
        return;
      }
      setLocation(newValue); // Update state with the selected location
      setuserlocationerror("");
    }
  };

  const handleUserLocationInputChange = (
    // Handle user input
    event: React.SyntheticEvent<Element, Event>,
    newInputValue: string
  ) => {
    if (newInputValue.length > 255) {
      setuserlocationerror("User Location cannot exceed 255 characters");
      return;
    }
    setLocation(newInputValue); // Update state with user-typed value
    setuserlocationerror("");
  };

  // const handleKeyInterestsChange = (value: string) => {
  //   if (value.length > 255) {
  //     setkeyinterestserror(
  //       "Key Areas of Interest cannot exceed 255 characters"
  //     );

  //     setTimeout(() => {
  //       setcompanyerror("");
  //     }, 2000); // 2000 milliseconds = 2 seconds
  //     return;
  //   }
  //   setKeyInterests(value);
  //   setkeyinterestserror("");
  // };

  const handleCustomizedPromptingChange = (value: string) => {
    setCustomizedPrompting(value);
  };

  const handlePersonizationChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.checked && formattedAreasOfInterest === "") {
      setModalMsg(
        "AI-generated current areas of interest are updated weekly, reflecting your recent conversations."
      );
      setShowModal(true);
    }
    setPersonalization(event.target.checked);
  };

  const checkIfChanged = () => {
    if (
      originalprofile &&
      (originalprofile.company !== company ||
        originalprofile.location !== location ||
        JSON.stringify(originalprofile.industry) !==
          JSON.stringify(selectedIndustries) || // Compare arrays
        // JSON.stringify(originalprofile.governing_law_country) !==
        //   JSON.stringify(selectedCountries) || // Compare arrays
        // JSON.stringify(originalprofile.areas_of_interest) !==
        //   JSON.stringify(formatKeyInterests(keyinterests)) || // Compare JSON format of key interests
        originalprofile.personalization !== personalization ||
        originalprofile.role !== role ||
        originalprofile.customized_prompting !== customizedPrompting)
    ) {
      setSaveDisabled(false);
    } else {
      setSaveDisabled(true);
    }
  };

  // Trigger checkIfChanged whenever any state variable changes
  useEffect(() => {
    checkIfChanged();
  }, [
    company,
    location,
    selectedIndustries,
    // selectedCountries,
    // keyinterests,
    personalization,
    role,
    customizedPrompting,
  ]);

  // Function to determine how many options to display based on screen width
  const getVisibleOptionCount = () => {
    const screenWidth = window.innerWidth;

    if (screenWidth < 1100) {
      return 2; // Show only 1 option for mobile
    } else if (screenWidth < 1600) {
      return 4; // Show 3 options for larger screens
    } else {
      return 6; // Show 5 options for larger screens
    }
  };

  // const getVisibleOptionCountCountry = () => {
  //   const screenWidth = window.innerWidth;

  //   if (screenWidth < 900) {
  //     return 1; // Show only 3 option for mobile
  //   } // Show 5 options for tablets
  //   else if (screenWidth < 1200) {
  //     return 2; // Show 9 options for larger screens
  //   } else if (screenWidth < 1600) {
  //     return 3; // Show 9 options for larger screens
  //   } else {
  //     return 4; // Show 9 options for larger screens
  //   }
  // };

  // const formatKeyInterests = (input: string): { [key: string]: string[] } => {
  //   if (!input.trim()) return {}; // Handle empty input

  //   const interestsArray = input.split(",").map((interest) => interest.trim()); // Split and trim each interest

  //   // Assuming you want to group all topics under a generic "Topic"
  //   return {
  //     Topic: interestsArray, // Assign all interests to "Topic"
  //   };
  // };
  const handleSave = () => {
    // Save user profile data

    const updatedProfile = {
      ...userprofile, // Spread the existing user profile
      // areas_of_interest: formatKeyInterests(keyinterests),
      company: company,
      location: location,
      industry: selectedIndustries,
      // governing_law_country: selectedCountries,
      personalization: personalization,
      role: role,
      customized_prompting: customizedPrompting,
    };

    updateUserProfileDetails(updatedProfile).then((response) => {
      if (response.ok) {
        fetchUserProfile(); // Fetch updated user profile
        setModalMsg("User profile updated successfully");
        setShowModal(true);
      } else {
        setModalMsg("Failed to update user profile");
        setShowModal(true);
      }
    });
  };

  // Fetch data after component mounts
  useEffect(() => {
    const fetchInitialData = async () => {
      // Fetch companies, locations, industries
      const fetchCompanies = async () => {
        const response = await getallcompanies();
        if (response.ok) {
          const data = await response.json();
          setCompanyOptions(data);
        }
      };
      const fetchLocations = async () => {
        const response = await getalllocations();
        if (response.ok) {
          const data = await response.json();
          setLocationOptions(data);
        }
      };
      const fetchIndustries = async () => {
        const response = await getallindustries();
        if (response.ok) {
          const data = await response.json();
          setIndustryOptions(data);
        }
      };

      const fetchRoles = async () => {
        const response = await getRoles();
        if (response.ok) {
          const data = await response.json();
          setRoleOptions(data);
        }
      };

      await Promise.all([
        fetchCompanies(),
        fetchLocations(),
        fetchIndustries(),
        fetchRoles(),
      ]);
    };

    fetchInitialData();

    fetchUserProfile();
  }, []);

  const fetchUserProfile = async () => {
    const response = await getUserProfileDetails();
    if (response.ok) {
      const data = await response.json();
      setUserProfile(data);
      setOriginalProfile(data);
      // const areasOfInterestArray = Object.values(
      //   data.areas_of_interest || {}
      // ).flat();
      // const areasOfInterestString = areasOfInterestArray.join(", ");

      // setKeyInterests(areasOfInterestString); // Set the comma-separated string
      setCompany(data.company || ""); // Safely access company
      setLocation(data.location || ""); // Safely access user_location
      setSelectedIndustries(data.industry ? data.industry : []); // Safely access industry

      const formattedAreas = Object.entries(data.gen_areas_of_interest || {})
        .map(([key, value]) => `${key}: ${value}`)
        .join("\n");
      setFormattedAreasOfInterest(formattedAreas);
      setPersonalization(
        data.personalization !== undefined ? data.personalization : true
      );
      setRole(data.role || "");
      setCustomizedPrompting(data.customized_prompting || "");
    }
    setLoading(false); // Stop loading once data is fetched
  };

  if (loading) {
    // Show loader until user profile is fetched
    return <Loader />;
  }
  return (
    <div className={`${styles.padding20}`}>
      <Stack tokens={{ childrenGap: 10 }}>
        {/* Modal Header */}
        <Stack.Item>
          <Text
            role="heading"
            aria-level={2}
            className={`${styles.userProfileLabel}`}
          >
            User Profile
          </Text>
        </Stack.Item>
        <Stack
          horizontal
          tokens={{ childrenGap: 20 }}
          className={`${styles.width100}`}
        >
          <Stack.Item grow className={`${styles.flex1}`}>
            <Autocomplete
              options={companyOptions.map((option) => option.name)} // Extract company names
              value={company} // Selected company value
              onChange={handleCompanyChange} // Handle selection
              onInputChange={handleCompanyInputChange} // Handle user input
              freeSolo
              filterOptions={(options, { inputValue }) => {
                if (!inputValue.trim()) {
                  return options.slice(0, maxOptions); // Return top options if input is empty
                }

                const filteredOptions = options.filter(
                  (option) =>
                    option
                      .toLowerCase()
                      .startsWith(inputValue.trim().toLowerCase()) // Trim input value and match case-insensitive
                );

                return filteredOptions.slice(0, maxOptions); // Limit to maxOptions (e.g., 10)
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Where I Work (Company)"
                  placeholder="Type or select company"
                  fullWidth
                  inputProps={{
                    ...params.inputProps, // Pass down default props
                    maxLength: 255, // Set the max length here
                  }}
                />
              )}
            />

            <div className={`${styles.error}`}>{companyerror}</div>
          </Stack.Item>
          <Stack.Item grow className={`${styles.flex1}`}>
            {/* Autocomplete for User Location */}
            <Autocomplete
              options={locationoptions.map((option) => option.name)} // Extract user location names
              value={location} // Selected user location value
              onChange={handleUserLocationChange} // Handle selection
              onInputChange={handleUserLocationInputChange} // Handle user input
              freeSolo
              filterOptions={(options, { inputValue }) => {
                const filteredOptions = options.filter(
                  (option) =>
                    option.toLowerCase().startsWith(inputValue.toLowerCase()) // Filter based on input value
                );
                return filteredOptions.slice(0, maxOptions); // Limit the displayed options to maxOptions (e.g., 10)
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Location"
                  placeholder="Type or select location"
                  fullWidth
                  inputProps={{
                    ...params.inputProps, // Pass down default props
                    maxLength: 255, // Set the max length here
                  }}
                />
              )}
            />
            <div className={`${styles.error}`}>{userlocationerror}</div>
          </Stack.Item>
        </Stack>
        <Stack
          horizontal
          tokens={{ childrenGap: 20 }}
          className={`${styles.width100}`}
        >
          <Stack.Item grow className={`${styles.flex1}`}>
            {/* Material-UI Multi-select for Industry */}
            <FormControl fullWidth>
              <InputLabel id="industry-select-label">
                Industry/Sector
              </InputLabel>
              <Select
                labelId="industry-select-label"
                id="industry-select"
                multiple
                value={selectedIndustries ? selectedIndustries : []} // Selected industries
                onChange={handleIndustryChange} // Handle selection
                renderValue={(selected) => {
                  const visibleCount = getVisibleOptionCount(); // Get visible count based on screen width
                  const limitedSelection = selected
                    .slice(0, visibleCount)
                    .join(", ");
                  const remainingCount = selected.length - visibleCount;
                  return selected.length > visibleCount
                    ? `${limitedSelection}+${remainingCount}`
                    : limitedSelection;
                }}
                fullWidth // Make responsive
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 200, // Set the max height for the dropdown (in px)
                      width: "40%", // Set the width to auto
                    },
                  },
                }}
              >
                {industryOptions.map((industry) => (
                  <MenuItem key={industry.name} value={industry.name}>
                    <Checkbox
                      checked={selectedIndustries.indexOf(industry.name) > -1}
                    />
                    <ListItemText primary={industry.name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack.Item>
        </Stack>

        <Stack>
          <Stack.Item grow className={`${styles.flex1}`}>
            {/* Autocomplete for User Location */}
            <Autocomplete
              options={roleOptions.map((option) => option.name)} // Extract user location names
              value={role} // Selected user location value
              onChange={handleRoleChange} // Handle selection
              onInputChange={handleRoleInputChange} // Handle user input
              freeSolo
              filterOptions={(options, { inputValue }) => {
                const filteredOptions = options.filter(
                  (option) =>
                    option.toLowerCase().startsWith(inputValue.toLowerCase()) // Filter based on input value
                );
                return filteredOptions.slice(0, maxOptions); // Limit the displayed options to maxOptions (e.g., 10)
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Role"
                  placeholder="Type or select role"
                  fullWidth
                  inputProps={{
                    ...params.inputProps, // Pass down default props
                    maxLength: 255, // Set the max length here
                  }}
                />
              )}
            />
          </Stack.Item>
        </Stack>
        <Stack>
          <Stack.Item className={`${styles.width100}`}>
            <TextField
              label={
                customizedPrompting
                  ? "Customized Prompting"
                  : "Enter a brief description of your role and your key areas of interest. For example: 'I am a broker interested in carbon offsets and carbon projects in Asia.'"
              }
              value={customizedPrompting} // Display the current areas of interest
              multiline
              rows={3}
              fullWidth
              onChange={(e) => handleCustomizedPromptingChange(e.target.value)}
            />
          </Stack.Item>
        </Stack>
        <Stack>
          <Stack.Item>
            <FormControlLabel
              control={
                <Checkbox
                  checked={personalization} // Bind the checkbox to state
                  onChange={handlePersonizationChange} // Handle state change
                />
              }
              label="Activate Personalization - This generates your current area of interests based on your recent conversations"
            />
          </Stack.Item>
        </Stack>
        <Stack>
          <Stack.Item className={`${styles.width100}`}>
            <TextField
              label={
                formattedAreasOfInterest
                  ? "Current Areas of Interest"
                  : "AI-generated current areas of interest are updated weekly, reflecting your recent conversations."
              }
              value={formattedAreasOfInterest} // Display the current areas of interest
              multiline
              rows={5}
              InputProps={{ readOnly: true }} // Read-only mode
              fullWidth
              style={{ pointerEvents: "none" }} // Prevent interaction (focus/click)
              onFocus={(e) => e.target.blur()} // Immediately blur to prevent focus
            />
          </Stack.Item>
          <Stack.Item align="end" className={`${styles.marginTop20}`}>
            <CommandBarButton
              role="button"
              styles={{
                icon: {
                  color: "var(--default)",
                },
                iconDisabled: {
                  cursor: "not-allowed",
                  color: "var(--secondary)",
                  opacity: "30%",
                },
                root: {
                  color: "var(--default)",
                  backgroundColor: "var(--secondary)",
                },
                rootDisabled: {
                  backgroundColor: "var(--secondary)",
                  color: "var(--default)",
                  cursor: "not-allowed",
                  opacity: "30%",
                },
                rootHovered: {
                  backgroundColor: "var(--secondary)",
                  color: "var(--default)",
                },
                iconHovered: {
                  color: "var(--default)",
                },
              }}
              className={styles.newChatIcon}
              text={"Save"}
              onClick={handleSave}
              aria-label="Save Profile"
              title={"Save Profile"}
              disabled={saveDisabled}
            />
          </Stack.Item>
        </Stack>
        {showModal && (
          <Modal
            show={showModal}
            onHide={() => {
              setShowModal(false);
            }}
            centered
          >
            <Modal.Body>{modalMsg}</Modal.Body>
            <Modal.Footer>
              <Button
                id="profileOk"
                className={styles.popBtn}
                variant="secondary"
                onClick={() => {
                  setShowModal(false);
                }}
              >
                OK
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </Stack>
    </div>
  );
};
